import { render, staticRenderFns } from "./EmptyComponent.vue?vue&type=template&id=b532a72a&scoped=true"
import script from "./EmptyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmptyComponent.vue?vue&type=style&index=0&id=b532a72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b532a72a",
  null
  
)

export default component.exports